import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getExcelReportCertificate = (start, end, type = 'TODAS') => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/certification/vehCertificationList/Excel/${start}/${end}?type=${type}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_XLSX_CERTIFICATION,
        ActionTypes.FETCHED_XLSX_CERTIFICATION,
        [ActionTypes.FETCHED_XLSX_CERTIFICATION_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getListVehCerticate = (start, end, type = 'TODAS') => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/certification/vehCertificationList/${start}/${end}?type=${type}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_LIST_VEHICLE_CERTIFICATION,
        [
          () => {
            dispatch(getExcelReportCertificate(start, end, type));
            return {
              'type': ActionTypes.FETCHED_LIST_VEHICLE_CERTIFICATION,
            };
          },
        ],
        [(ActionTypes.FETCHED_LIST_VEHICLE_CERTIFICATION_FAILED, (error) => buildErrorMessage(error))],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getPdfCertificate = (idRequest) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/certification/vehCertifications/${idRequest}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_PDF_CERTIFICATION,
        [() => {
          return {
            'type': ActionTypes.FETCHED_PDF_CERTIFICATION,
            'payload': idRequest,
          };
        }],
        [ActionTypes.FETCHED_PDF_CERTIFICATION_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getCertificateOwner = (idRequest) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/certification/vehCertifications/owner/${idRequest}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_VEHICLE_CERTIFICATE_OWNER,
        [() => {
          return {
            'type': ActionTypes.FETCHED_VEHICLE_CERTIFICATE_OWNER,
            'payload': idRequest,
          };
        }],
        [ActionTypes.FETCHED_VEHICLE_CERTIFICATE_OWNER_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getCpoLabel = (idRequest) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/certification/vehCertifications/label/${idRequest}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_VEHICLE_CPO_LABEL,
        [() => {
          return {
            'type': ActionTypes.FETCHED_VEHICLE_CPO_LABEL,
            'payload': idRequest,
          };
        }],
        [ActionTypes.FETCHED_VEHICLE_CPO_LABEL_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const clearPdf = () => {
  return {
    'type': ActionTypes.CLEAR_PDF_CERTIFICATION,
  };
};


export const clearPdfOwner = () => {
  return {
    'type': ActionTypes.CLEAR_VEHICLE_CERTIFICATION_OWNER,
  };
};

export const clearCpoLabel = () => {
  return {
    'type': ActionTypes.CLEAR_VEHICLE_CPO_LABEL,
  };
};
